<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="4">
            <v-card class="elevation-12 mt-10 mt-lg-16 mt-md-16 mt-sm-16">
                <v-card-title class="justify-center" style="
                                  background-color: rgb(30, 101, 105);
                                  margin-bottom: 30px;
                                  padding-top: 20px !important;
                                ">
                    <img src="../../assets/img/logo_w.svg" style="width: 100%" alt="" />
                </v-card-title>

                <v-card-text class="justify-center px-9 px-md-13 px-sm-9 px-lg-16">
                    <v-row justify="center">
                        <v-container class="ma-0 pa-0 mw-100">{{ $t('Navigation.welcomeTextQuickn8') }}</v-container>
                    </v-row>
                    <br />
                    <v-row justify="center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="text-center">
                            <p justify="center">
                                {{ $t('provided_by_sign8') }}
                                <img src="../../assets/img/logo_g.svg" style="width: 30%" alt="" />
                            </p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import i18n from "../../i18n";
import { log } from "@/helpers/logger";
import cookie from "vue-cookies";

export default {
    name: "WorkflowLoginQuickn8",
    title: i18n.t("WorkflowLogin.Title"),
    components: {
        CustomButton,
    },
    props: ["workflow_id", "signer_id"],
    computed: {
        loadingState() {
            return this.$store.state.loading;
        },
    },
    async created() {
        this.$vuetify.theme.themes.light.primary = '#1E6569';
        let interface_data = "#1E6569";

        await this.$store
            .dispatch("data/getInterfaceByWorkflow", this.workflow_id)
            .then((res) => {
                log(
                    "Quickn8.index.created() - get Interface for workflow " +
                    this.workflow_id,
                    "info"
                );

                this.logo_small = res.logo;
                interface_data = res.style;
            })
            .catch((err) => {
                log("Quickn8.index.created() - " + err, "error");
            })
            .finally(() => {
                this.mainColor = interface_data;
                this.workflow.mainColor = interface_data;
                this.$vuetify.theme.themes.light.primary = interface_data;
                this.$vuetify.theme.themes.light.secondary = interface_data;
                this.$vuetify.theme.themes.light.accent = interface_data;
            });

        let data = {
            workflow_id: this.workflow_id,
            signer_id: this.signer_id,
            workflow: this.workflow,
        };
        await this.$store
            .dispatch("auth/workflowLogin", data)
            .then(async (res) => {
                log(
                    "Quickn8.index.login() - login to workflow " +
                    this.workflow_id,
                    "info"
                );
                this.$store.commit("data/set_signed", true);

                if (res.signer_type === 'a_signature' || res.signer_type === 'a_seal') {
                    setTimeout(function () {
                        window.location = "/workflow/" +
                            data.workflow_id +
                            "/" +
                            data.signer_id +
                            "/authenticate";
                    }, 2500);
                } else {
                    await this.$store
                        .dispatch("data/getCertificate")
                        .then((res) => {
                            cookie.set("certificate_exists", res.certificate_exists, 60 * 30);

                            if (res.signer_exists && res.certificate_exists) {
                                this.$router.push(
                                    "/workflow/" +
                                    this.workflow_id +
                                    "/" +
                                    this.signer_id +
                                    "/authenticate2fa"
                                );
                            } else {
                                this.$router.push(
                                    "/workflow/" +
                                    this.workflow_id +
                                    "/" +
                                    this.signer_id +
                                    "/identify"
                                );
                            }
                        })
                        .catch((err) => {
                            log(
                                "Quickn8.index.login() - " + err.message,
                                "error"
                            );
                        });
                }
            })
            .catch((err) => {
                log("Quickn8.index.login() - " + err, "error");
            });
    },
    data() {
        return {
            mainColor: "rgb(30, 101, 104)",
            logo_small: "",
            workflow: {
                password: "",
                mainColor: "rgb(30, 101, 104)",
                gtcChecked: true,
            }
        };
    },
};
</script>

<style>
:root {
    --white: #fff;
    --black: #000000;
    --turquoise: #1e6668;
}

.Cookie--bottom {
    background-color: var(--white);
}

.Cookie--bottom .cookieButton {
    background-color: var(--turquoise);
    box-shadow: none;
    outline: none;
    border: none;
    color: var(--white);
    padding: 0.75rem 1.25rem;
}

.type {
    color: var(--v-primary-base);
}
</style>
